import { loadCurrentMemberJourneys, loadPastMemberJourneys, MemberJourneyListType } from '@vista/omnichannel-components-domain';
export const loadJourneyListByType = async (data, startWeekOnSunday) => {
    switch (data.type) {
        case MemberJourneyListType.Active:
        case MemberJourneyListType.NextJourney: {
            await loadCurrentMemberJourneys();
            break;
        }
        case MemberJourneyListType.Recent: {
            await loadPastMemberJourneys(data.limit, startWeekOnSunday, data.initialLoad);
            break;
        }
        default:
    }
};
